import { FullHeightCalculatorHOC, HoloHelmet } from 'common-js/components';
import { type FC } from 'react';
import SimSubMenu from 'sims/components/SubMenu';
import ActivityHistoryDetailsPanel from './ActivityHistoryDetailsPanel';

interface ActivityHistoryDetailsProps {
  params: {
    batchJobId: string;
  };
}

const ActivityHistoryDetails: FC<ActivityHistoryDetailsProps> = ({ params: { batchJobId } }) => (
  <>
    <HoloHelmet title="Activity" />
    <SimSubMenu />
    <FullHeightCalculatorHOC accountForDrawer backgroundColor="#F2F3F5">
      <div className="container">
        <div className="ActivityHistoryDetails" data-testid="activity-history-details-wrapper">
          <ActivityHistoryDetailsPanel batchJobId={batchJobId} />
        </div>
      </div>
    </FullHeightCalculatorHOC>
  </>
);

export default ActivityHistoryDetails;
